module.exports = __webpack_public_path__ + "static/media/tu12x.6d170830.png";